import React, { useState, useEffect } from "react";
import { FaCheck } from "react-icons/fa";
import { QuestionnaireHeader } from "./QuestionnaireHeader";
import { QuestionnaireFooter } from "./QuestionnaireFooter";
import { Input } from "./common/Input";

export const QuestionnaireQuestionWithTextPage = ({
	def,
	onRespond,
	currentResponse,
}) => {
	const [selectedOption, setSelectedOption] = useState("");
	const [defaultOption, setDefaultOption] = useState("");
	const [optionDef, setOptionDef] = useState({});
	const [text, setText] = useState("");
	const [enableText, setEnableText] = useState(false);

	const changeText = (e) => {
		const text = e.target.value;

		setText(text);

		const response = {};
		response.id = def.id;
		response.value = { option: selectedOption, text };

		onRespond(response);
	};

	useEffect(() => {
		let opt = "";
		let text = "";

		if (def.options) {
			for (const o of def.options) {
				if (o.default) {
					setOptionDef(o);
					setEnableText(o.enableText);

					opt = o.value;
					text = o.text || "";
					break;
				}
			}
		}

		setDefaultOption(opt);
		setText(text);

		if (!currentResponse) {
			const response = {};
			response.id = def.id;
			response.value = { option: opt, text };

			onRespond(response);
		}
	}, [def]);

	useEffect(() => {
		let opt;
		let text;
		if (currentResponse && currentResponse.value) {
			opt = currentResponse.value.option;
			text = currentResponse.value.text;
		} else if (def.answer) {
			opt = def.answer.option;
			text = def.answer.text;
			handleOptionChange({ target: { value: def.answer, checked: true } });
		} else {
			opt = optionDef?.option || "";
			text = optionDef?.text || "";
		}

		let _odef = {};
		for (const o of def.options) {
			if (o.value.toString() === opt.toString()) {
				_odef = o;
				break;
			}
		}

		setOptionDef(_odef);
		if (_odef.enableText) {
			setText(text);
			setEnableText(true);
		} else {
			setText("");
			setEnableText(false);
		}

		setSelectedOption(opt);
	}, [currentResponse, defaultOption, def]);

	const handleOptionChange = (e) => {
		let value = e.target.value;
		const checked = e.target.checked;

		if (!checked) {
			value = defaultOption;
		}
		setSelectedOption(value);

		let _odef = {};
		for (const o of def.options) {
			if (o.value.toString() === value.toString()) {
				_odef = o;
				break;
			}
		}

		setOptionDef(_odef);
		let _text = "";
		let _enableText = false;
		if (_odef.enableText) {
			_text = text;
			_enableText = true;
		}

		setText(_text);
		setEnableText(_enableText);

		const response = {};
		response.id = def.id;
		response.value = { option: value, text };

		onRespond(response);
	};

	const renderOptions = (s) => {
		return def.options
			? def.options.map((option, i) => (
					<div key={`${i}_container`} className={option.hidden ? "hidden" : ""}>
						<label
							key={`${i}_label`}
							className={`${
								s === option.value.toString()
									? `bg-black text-white font-medium`
									: "bg-gray-100 text-black"
							} text-right text-base sm:text-lg leading-5 sm:leading-6 font-normal rounded-full mx-3 option pr-2 pl-7 py-2.5 cursor-pointer flex items-center justify-end my-3 lg:my-4`}
						>
							{option.label}
							<span
								className={`flex flex-0-0-auto justify-center items-center w-4 h-4 text-white border border-gray-400 rounded mx-2.5`}
							>
								{s === option.value.toString() && <FaCheck size={8} />}
							</span>
							<input
								key={`${i}_input`}
								name={def.title}
								value={option.value.toString()}
								className={"hidden "}
								type={def.forceSelect ? "radio" : "checkbox"}
								checked={s === option.value.toString()}
								onChange={handleOptionChange}
							/>
						</label>
					</div>
			  ))
			: null;
	};

	return (
		<>
			<QuestionnaireHeader def={def} />

			<div>{renderOptions(selectedOption)}</div>
			<div className="mx-3">
				<Input
					id="input"
					value={text}
					onChange={changeText}
					placeholder={def.placeholder || "Other"}
					multiline={def.multiline}
					minRows={def.minRows}
					maxRows={def.maxRows}
					rows={def.rows}
					required={def.required}
					inputType={def.inputType || "text"}
					fullWidth={true}
					classes={def.classes}
					autoFocus={def.autoFocus}
					color={def.color}
					disabled={!enableText}
				/>
			</div>

			<QuestionnaireFooter def={def} />
		</>
	);
};
